import { useContext, useEffect, useMemo, useState } from "react"
import { getData } from "src/actions/getData";
import MiniInfoButton from "src/components/MiniInfoButton";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import shopContext from "src/context/shopContext";
import { numberWithCommas } from "src/utils/thousandSeprator";
import { TbReload } from "react-icons/tb";
import { FilterFn } from "src/components/Table/FilterFn";
import FilterColumn from "src/components/Table/FilterColumn";

import moment from 'jalali-moment';

export default function CommercialSales() {

    const { sales, setSales } = useContext(shopContext);
    const { products, setProducts } = useContext(shopContext);

    useEffect(() => {
        const controller = new AbortController(); // برای لغو درخواست
        const signal = controller.signal;

        if (!sales) {
            getData(setSales, "/sales", {}, signal);
        }

        return () => {
            controller.abort();
        };
    }, [])

    useEffect(() => {
        const controller = new AbortController(); // برای لغو درخواست
        const signal = controller.signal;

        if (!products) {
            getData(setProducts, "/products", {}, signal);
        }

        return () => {
            controller.abort();
        };
    }, [products])

    const salesWithProducts = useMemo(() => {
        if (sales && products) {
            const salesWithCalculatedFactor = sales.map(sale => ({ ...sale, calculatedFactor: (((sale.taxFreeBasePrice * sale.quantity) - sale.financialTotalDiscount + sale.addition + sale.totalNetTax) / 10) }))
            return salesWithCalculatedFactor.map(sale => {
                return {
                    ...sale,
                    fullName: sale.fullName == "tapsi shop" ? "tapsi shop" : sale.fullName == "snapp shop" ? "snapp shop" : "سایر",
                    city: sale.fullName == "tapsi shop" ? "tapsi shop" : sale.fullName == "snapp shop" ? "snapp shop" : sale.city == "تهران" ? "تهران" : "سایر",
                    ...products.find(product => product.id == sale.product_id)
                }
            })
        }
        return false;
    }, [sales, products]);



    const columns = [
        {
            id: "image",
            cell: (info) => (<img className="w-[80px] max-w-[80px] rounded-lg" src={info.getValue()} />),
            header: "تصویر",
        },
        {
            id: "name",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نام محصول",
        },
        {
            id: "sku",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "sku",
        },
        {
            id: "orderId",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "شماره سفارش",
        },
        {
            id: "fullName",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نام خریدار",
        },
        {
            id: "city",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "شهر",
        },
        {
            id: "phoneNumber",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "شماره خریدار",
        },
        {
            id: "brand",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "برند",
        },
        {
            id: "categoriesString",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "دسته بندی",
        },
        {
            id: "taxRate",
            cell: (info) => info.getValue() ? "%" + info.getValue() : "---",
            header: "کلاس مالیات",
        },
        {
            id: "quantity",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "تعداد",
        },
        {
            id: "calculatedFactor",
            cell: (info) => info.getValue() ? numberWithCommas(info.getValue()) + " تومان" : "---",
            header: "خالص دریافتی کل (تومان)",
        },
        {
            id: "statusFa",
            cell: (info) => info.getValue() ? <MiniInfoButton text={info.getValue()} color={info.row.original.color} /> : "---",
            header: "وضعیت سفارش",
        },
        {
            id: "date_paid",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue(), "en", "YYYY-MM-DD HH:mm:ss")
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            filterFn: (row, columnId, filterValue) => {
                // type can be "object" , "array" , "string" , "number"
                return FilterFn(row, columnId, filterValue, "date");
            },
            meta: {
                filterComponent: (setFilterValue) => {
                    return <FilterColumn setFilterValue={setFilterValue} type="date" />;
                },
            },
            header: "تاریخ پرداخت",
        },
    ];


    return (
        <>
            <PageHeader
                title="لیست فروش‌ها"
            // btnTitle="بروزرسانی"
            // handleClick={() => {
            //     setSales();
            //     getData(() => { }, "/orders/purgeCache");
            //     getData(setSales, "/sales");
            // }}
            // btnIcon={<TbReload className="ml-1" size="20" />}
            // isBtnLoading={!sales}
            />
            <Table data={salesWithProducts} columns={columns} CSVExportPermission="exportMarketingSales" tableName="marketingSales" />

        </>
    )
}
